(() => {

  const ROOT_SELECTOR =
    '[data-lm-fuel-station]';


  function createMoneyFormatter(currency) {

    try {

      return new Intl.NumberFormat(
        undefined,
        {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );

    } catch (error) {

      return new Intl.NumberFormat(
        'en-US',
        {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );

    }

  }


  function centsToMoney(cents) {

    if (
      cents === undefined ||
      cents === null ||
      cents === ''
    ) {
      return null;
    }


    const value =
      Number(cents);


    return Number.isFinite(value)
      ? value / 100
      : null;

  }


  function parseOctane(title) {

    if (!title) {
      return null;
    }


    const match =
      title.match(
        /(\d{2,3})\s*octane/i
      );


    if (!match) {
      return null;
    }


    const value =
      Number(
        match[1]
      );


    return Number.isFinite(value)
      ? value
      : null;

  }


  function cleanDescriptor(
    title,
    code
  ) {

    let value =
      title || '';


    if (code) {

      const escaped =
        code.replace(
          /[.*+?^${}()|[\]\\]/g,
          '\\$&'
        );


      value =
        value.replace(
          new RegExp(
            `^${escaped}\\s*`,
            'i'
          ),
          ''
        );

    }


    value =
      value
        .replace(
          /\b\d{2,3}\s*octane\b/gi,
          ''
        )
        .replace(
          /\s*[–—-]\s*/g,
          ' '
        )
        .replace(
          /\s+/g,
          ' '
        )
        .trim();


    return value ||
      'Fuel Factory Race Fuel';

  }


  function parseBoolean(value) {

    return String(
      value ?? ''
    )
      .trim()
      .toLowerCase() ===
      'true';

  }


  function initStation(root) {

    if (
      !root ||
      root.dataset.lmInitialized ===
        'true'
    ) {
      return;
    }


    root.dataset.lmInitialized =
      'true';


    const fuels =
      Array.from(
        root.querySelectorAll(
          '[data-lm-fuel]'
        )
      );


    if (!fuels.length) {
      return;
    }


    const filters =
      Array.from(
        root.querySelectorAll(
          '[data-lm-filter]'
        )
      );


    const money =
      createMoneyFormatter(
        root.dataset.currency ||
        'USD'
      );


    const animation =
      root.dataset.animation ||
      'race-start';


    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    const autoCycle =
      root.dataset.autoCycle ===
      'true';


    const cycleSeconds =
      Math.max(
        4,
        Number(
          root.dataset.cycleSeconds ||
          7
        )
      );


    const el = {

      toggle:
        root.querySelector(
          '[data-lm-toggle]'
        ),

      toggleLabel:
        root.querySelector(
          '[data-lm-toggle-label]'
        ),

      pickupQuick:
        root.querySelector(
          '[data-lm-pickup-quick]'
        ),

      pickupFilterBanner:
        root.querySelector(
          '[data-lm-pickup-filter-banner]'
        ),

      clearPickup:
        root.querySelector(
          '[data-lm-clear-pickup]'
        ),


      teaserCode:
        root.querySelector(
          '[data-lm-teaser-code]'
        ),

      teaserPrimary:
        root.querySelector(
          '[data-lm-teaser-primary]'
        ),

      teaserSecondary:
        root.querySelector(
          '[data-lm-teaser-secondary]'
        ),

      teaserTitle:
        root.querySelector(
          '[data-lm-teaser-title]'
        ),

      teaserPail:
        root.querySelector(
          '[data-lm-teaser-pail]'
        ),

      teaserDrum:
        root.querySelector(
          '[data-lm-teaser-drum]'
        ),


      code:
        root.querySelector(
          '[data-lm-code-display]'
        ),

      primary:
        root.querySelector(
          '[data-lm-primary-display]'
        ),

      secondary:
        root.querySelector(
          '[data-lm-secondary-display]'
        ),

      octane:
        root.querySelector(
          '[data-lm-octane]'
        ),

      descriptor:
        root.querySelector(
          '[data-lm-descriptor]'
        ),

      shop:
        root.querySelector(
          '[data-lm-shop]'
        ),


      tree:
        root.querySelector(
          '[data-lm-tree]'
        ),


      gaugeNeedle:
        root.querySelector(
          '[data-lm-gauge-needle]'
        ),

      gaugeProgress:
        root.querySelector(
          '[data-lm-gauge-progress]'
        ),

      gaugeReading:
        root.querySelector(
          '[data-lm-gauge-reading]'
        ),


      pailCard:
        root.querySelector(
          '[data-lm-pail-card]'
        ),

      drumCard:
        root.querySelector(
          '[data-lm-drum-card]'
        ),


      pailStatus:
        root.querySelector(
          '[data-lm-pail-status]'
        ),

      drumStatus:
        root.querySelector(
          '[data-lm-drum-status]'
        ),


      pailPrice:
        root.querySelector(
          '[data-lm-display-pail-price]'
        ),

      pailUnit:
        root.querySelector(
          '[data-lm-display-pail-unit]'
        ),

      drumPrice:
        root.querySelector(
          '[data-lm-display-drum-price]'
        ),

      drumUnit:
        root.querySelector(
          '[data-lm-display-drum-unit]'
        ),


      pailBadgeCode:
        root.querySelector(
          '[data-lm-pail-badge-code]'
        ),

      drumBadgeCode:
        root.querySelector(
          '[data-lm-drum-badge-code]'
        ),

      pailBadgeMeta:
        root.querySelector(
          '[data-lm-pail-badge-meta]'
        ),

      drumBadgeMeta:
        root.querySelector(
          '[data-lm-drum-badge-meta]'
        ),


      pailPickupBoard:
        root.querySelector(
          '[data-lm-pail-pickup-board]'
        ),

      drumPickupBoard:
        root.querySelector(
          '[data-lm-drum-pickup-board]'
        ),


      savings:
        root.querySelector(
          '[data-lm-savings]'
        ),

      savePerGallon:
        root.querySelector(
          '[data-lm-save-per-gallon]'
        ),

      savePercent:
        root.querySelector(
          '[data-lm-save-percent]'
        ),


      drumNotOffered:
        root.querySelector(
          '[data-lm-drum-not-offered]'
        ),


      bulkSave:
        root.querySelector(
          '[data-lm-bulk-save]'
        ),

      bulkSaveText:
        root.querySelector(
          '[data-lm-bulk-save-text]'
        )

    };


    const openText =
      root.dataset.openLabel ||
      'OPEN FUEL STATION';


    const closeText =
      root.dataset.closeLabel ||
      'CLOSE FUEL STATION';


    let activeIndex =
      0;


    let activeFilter =
      'all';


    let autoTimer =
      null;


    let treeTimers =
      [];


    let userInteracted =
      false;


    /* =====================================================
       FILTER HELPERS
    ===================================================== */


    function getFuelGroups(fuel) {

      return String(
        fuel.dataset.lmGroups ||
        ''
      )
        .split(/\s+/)
        .filter(Boolean);

    }


    function hasLocalPickup(fuel) {

      return parseBoolean(
        fuel.dataset
          .lmLocalPickup
      );

    }


    function fuelMatchesFilter(
      fuel,
      filterName
    ) {

      if (
        filterName ===
        'all'
      ) {

        return true;

      }


      if (
        filterName ===
        'pickup'
      ) {

        return hasLocalPickup(
          fuel
        );

      }


      return getFuelGroups(
        fuel
      ).includes(
        filterName
      );

    }


    function prepareFilters() {

      const available =
        new Set();


      let pickupCount =
        0;


      fuels.forEach(
        fuel => {

          getFuelGroups(
            fuel
          )
            .forEach(
              group => {

                available.add(
                  group
                );

              }
            );


          if (
            hasLocalPickup(
              fuel
            )
          ) {

            pickupCount++;

          }

        }
      );


      filters.forEach(
        filter => {

          const name =
            filter.dataset
              .lmFilter;


          if (
            name ===
            'pickup'
          ) {

            if (
              pickupCount ===
              0
            ) {

              filter.hidden =
                true;

            }


            return;

          }


          if (
            name !==
              'all' &&
            !available.has(
              name
            )
          ) {

            filter.hidden =
              true;

          }

        }
      );


      if (
        el.pickupQuick &&
        pickupCount === 0
      ) {

        el.pickupQuick.hidden =
          true;

      }

    }


    function applyFilter(
      name,
      renderFirst = true
    ) {

      activeFilter =
        name;


      filters.forEach(
        filter => {

          filter.classList.toggle(
            'is-active',
            filter.dataset
              .lmFilter ===
              name
          );

        }
      );


      fuels.forEach(
        fuel => {

          const visible =
            fuelMatchesFilter(
              fuel,
              name
            );


          fuel.classList.toggle(
            'is-filtered-out',
            !visible
          );

        }
      );


      if (
        el.pickupFilterBanner
      ) {

        el.pickupFilterBanner.hidden =
          name !==
          'pickup';

      }


      const activeFuel =
        fuels[
          activeIndex
        ];


      if (
        activeFuel &&
        !fuelMatchesFilter(
          activeFuel,
          name
        )
      ) {

        const nextIndex =
          fuels.findIndex(
            fuel =>
              fuelMatchesFilter(
                fuel,
                name
              )
          );


        if (
          nextIndex >=
          0
        ) {

          render(
            nextIndex,
            true
          );

        }


        return;

      }


      if (
        renderFirst &&
        name ===
          'pickup'
      ) {

        const firstPickup =
          fuels.findIndex(
            fuel =>
              hasLocalPickup(
                fuel
              )
          );


        if (
          firstPickup >=
          0
        ) {

          render(
            firstPickup,
            true
          );

        }

      }

    }


    /* =====================================================
       TREE
    ===================================================== */


    function clearTree() {

      treeTimers.forEach(
        clearTimeout
      );


      treeTimers =
        [];


      if (
        !el.tree
      ) {
        return;
      }


      el.tree
        .querySelectorAll(
          '.lm-tree__bulb'
        )
        .forEach(
          bulb => {

            bulb.classList.remove(
              'is-lit'
            );

          }
        );

    }


    function runTree(callback) {

      if (
        !el.tree ||
        reducedMotion ||
        animation !==
          'race-start'
      ) {

        callback?.();

        return;

      }


      clearTree();


      const bulbs =
        Array.from(
          el.tree.querySelectorAll(
            '.lm-tree__bulb'
          )
        );


      const sequence = [

        [0,0],

        [1,90],

        [2,230],

        [3,345],

        [4,460],

        [5,625]

      ];


      sequence.forEach(
        ([index,delay]) => {

          treeTimers.push(

            setTimeout(
              () => {

                if (
                  index ===
                  5
                ) {

                  [2,3,4]
                    .forEach(
                      amber => {

                        bulbs[
                          amber
                        ]?.classList.remove(
                          'is-lit'
                        );

                      }
                    );

                }


                bulbs[
                  index
                ]?.classList.add(
                  'is-lit'
                );

              },

              delay
            )

          );

        }
      );


      treeTimers.push(

        setTimeout(
          () => {

            callback?.();

          },

          650
        )

      );


      treeTimers.push(

        setTimeout(
          clearTree,
          1400
        )

      );

    }


    /* =====================================================
       MONEY
    ===================================================== */


    function renderMoney(
      element,
      value,
      suffix = ''
    ) {

      if (
        !element
      ) {
        return;
      }


      if (
        value ===
          null ||
        !Number.isFinite(
          value
        ) ||
        value <=
          0
      ) {

        element.textContent =
          'NOT AVAILABLE';


        return;

      }


      element.textContent =
        money.format(
          value
        ) +
        suffix;

    }


    /* =====================================================
       PACKAGE AVAILABILITY
    ===================================================== */


    function setAvailability(
      card,
      label,
      exists,
      available,
      validPrice
    ) {

      if (
        !card ||
        !label
      ) {
        return;
      }


      const usable =
        exists &&
        validPrice;


      card.classList.toggle(
        'is-unavailable',
        !usable ||
        !available
      );


      if (
        !exists ||
        !validPrice
      ) {

        label.textContent =
          'NOT OFFERED';

      } else if (
        !available
      ) {

        label.textContent =
          'SOLD OUT';

      } else {

        label.textContent =
          'AVAILABLE';

      }

    }


    /* =====================================================
       PICKUP BOARDS
    ===================================================== */


    function hidePickupBoard(
      board
    ) {

      if (
        board
      ) {

        board.hidden =
          true;

      }

    }


    function showPickupBoard(
      board
    ) {

      if (
        !board
      ) {
        return;
      }


      board.hidden =
        false;


      board.classList.remove(
        'is-firing'
      );


      void board.offsetWidth;


      board.classList.add(
        'is-firing'
      );

    }


    /* =====================================================
       GAUGE
    ===================================================== */


    function updateGauge(
      octane,
      primary
    ) {

      let fraction =
        .5;


      let reading =
        primary ||
        'RACE FUEL';


      if (
        octane !==
        null
      ) {

        fraction =
          (
            octane -
            90
          ) /
          35;


        fraction =
          Math.max(
            .06,
            Math.min(
              .96,
              fraction
            )
          );


        reading =
          `${octane} OCTANE`;

      } else if (
        primary ===
        'METHANOL'
      ) {

        fraction =
          .88;

      } else if (
        primary ===
        'ETHANOL'
      ) {

        fraction =
          .72;

      }


      if (
        el.gaugeNeedle
      ) {

        el.gaugeNeedle
          .style
          .transform =
          `rotate(${
            -90 +
            fraction *
            180
          }deg)`;

      }


      if (
        el.gaugeProgress
      ) {

        el.gaugeProgress
          .style
          .strokeDashoffset =
          String(
            299 *
            (
              1 -
              fraction
            )
          );

      }


      if (
        el.gaugeReading
      ) {

        el.gaugeReading
          .textContent =
          reading;

      }

    }


    /* =====================================================
       SAVINGS
    ===================================================== */


    function clearSavings() {

      if (
        el.savings
      ) {

        el.savings.hidden =
          true;

      }


      if (
        el.bulkSave
      ) {

        el.bulkSave.hidden =
          true;

      }

    }


    /* =====================================================
       RENDER
    ===================================================== */


    function performRender(
      index
    ) {

      const fuel =
        fuels[
          index
        ];


      if (
        !fuel
      ) {
        return;
      }


      activeIndex =
        index;


      fuels.forEach(
        (button,i) => {

          const active =
            i ===
            index;


          button.classList.toggle(
            'is-active',
            active
          );


          button.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );

        }
      );


      const code =
        fuel.dataset
          .lmCode ||
        'FUEL';


      const primary =
        fuel.dataset
          .lmPrimary ||
        'RACE FUEL';


      const secondary =
        fuel.dataset
          .lmSecondary ||
        '';


      const title =
        fuel.dataset
          .lmTitle ||
        code;


      const url =
        fuel.dataset
          .lmUrl ||
        '#';


      const octane =
        parseOctane(
          title
        );


      const descriptor =
        cleanDescriptor(
          title,
          code
        );


      const badgeMeta =
        octane !==
          null
          ? `${octane} OCTANE`
          : primary;


      const pailExists =
        fuel.dataset
          .lmPailExists ===
        'true';


      const drumExists =
        fuel.dataset
          .lmDrumExists ===
        'true';


      const pailAvailable =
        fuel.dataset
          .lmPailAvailable ===
        'true';


      const drumAvailable =
        fuel.dataset
          .lmDrumAvailable ===
        'true';


      const pailPickup =
        parseBoolean(
          fuel.dataset
            .lmPailPickupEligible
        );


      const drumPickup =
        parseBoolean(
          fuel.dataset
            .lmDrumPickupEligible
        );


      const pailPrice =
        centsToMoney(
          fuel.dataset
            .lmPailCents
        );


      const drumPrice =
        centsToMoney(
          fuel.dataset
            .lmDrumCents
        );


      const pailValid =
        pailExists &&
        pailPrice !==
          null &&
        pailPrice >
          0;


      const drumValid =
        drumExists &&
        drumPrice !==
          null &&
        drumPrice >
          0;


      const pailPerGallon =
        pailValid
          ? pailPrice /
            5
          : null;


      const drumPerGallon =
        drumValid
          ? drumPrice /
            54
          : null;


      /* IDENTITY */


      if (
        el.code
      ) {

        el.code.textContent =
          code;

      }


      if (
        el.primary
      ) {

        el.primary.textContent =
          primary;

      }


      if (
        el.secondary
      ) {

        el.secondary.textContent =
          secondary;

      }


      if (
        el.octane
      ) {

        el.octane.textContent =
          octane !==
            null
            ? `${octane} OCTANE`
            : primary;

      }


      if (
        el.descriptor
      ) {

        el.descriptor.textContent =
          descriptor;

      }


      if (
        el.shop
      ) {

        el.shop.href =
          url;

      }


      /* COLLAPSED */


      if (
        el.teaserCode
      ) {

        el.teaserCode.textContent =
          code;

      }


      if (
        el.teaserPrimary
      ) {

        el.teaserPrimary.textContent =
          primary;

      }


      if (
        el.teaserSecondary
      ) {

        el.teaserSecondary.textContent =
          secondary;

      }


      if (
        el.teaserTitle
      ) {

        el.teaserTitle.textContent =
          title;

      }


      if (
        el.teaserPail
      ) {

        el.teaserPail.textContent =
          pailValid
            ? money.format(
                pailPrice
              )
            : 'N/A';

      }


      if (
        el.teaserDrum
      ) {

        el.teaserDrum.textContent =
          drumValid
            ? money.format(
                drumPrice
              )
            : 'N/A';

      }


      /* TECH BADGES */


      if (
        el.pailBadgeCode
      ) {

        el.pailBadgeCode.textContent =
          pailValid
            ? code
            : 'N/A';

      }


      if (
        el.drumBadgeCode
      ) {

        el.drumBadgeCode.textContent =
          drumValid
            ? code
            : 'N/A';

      }


      if (
        el.pailBadgeMeta
      ) {

        el.pailBadgeMeta.textContent =
          pailValid
            ? badgeMeta
            : 'NOT OFFERED';

      }


      if (
        el.drumBadgeMeta
      ) {

        el.drumBadgeMeta.textContent =
          drumValid
            ? badgeMeta
            : 'NOT OFFERED';

      }


      /* STATUS */


      setAvailability(
        el.pailCard,
        el.pailStatus,
        pailExists,
        pailAvailable,
        pailValid
      );


      setAvailability(
        el.drumCard,
        el.drumStatus,
        drumExists,
        drumAvailable,
        drumValid
      );


      /* PAIL PRICE */


      if (
        pailValid
      ) {

        renderMoney(
          el.pailPrice,
          pailPrice
        );


        renderMoney(
          el.pailUnit,
          pailPerGallon,
          ' / GAL'
        );

      } else {

        if (
          el.pailPrice
        ) {

          el.pailPrice.textContent =
            'NOT AVAILABLE';

        }


        if (
          el.pailUnit
        ) {

          el.pailUnit.textContent =
            '5 GAL PAIL';

        }

      }


      /* DRUM PRICE */


      if (
        drumValid
      ) {

        renderMoney(
          el.drumPrice,
          drumPrice
        );


        renderMoney(
          el.drumUnit,
          drumPerGallon,
          ' / GAL'
        );

      } else {

        if (
          el.drumPrice
        ) {

          el.drumPrice.textContent =
            'NOT AVAILABLE';

        }


        if (
          el.drumUnit
        ) {

          el.drumUnit.textContent =
            '54 GAL DRUM';

        }

      }


      if (
        el.drumNotOffered
      ) {

        el.drumNotOffered.hidden =
          drumValid;

      }


      /* PICKUP */


      hidePickupBoard(
        el.pailPickupBoard
      );


      hidePickupBoard(
        el.drumPickupBoard
      );


      if (
        pailValid &&
        pailPickup
      ) {

        showPickupBoard(
          el.pailPickupBoard
        );

      }


      if (
        drumValid &&
        drumPickup
      ) {

        showPickupBoard(
          el.drumPickupBoard
        );

      }


      /* GAUGE */


      updateGauge(
        octane,
        primary
      );


      /* SAVINGS */


      clearSavings();


      if (
        pailValid &&
        drumValid &&
        drumPerGallon <
          pailPerGallon
      ) {

        const perGallonSavings =
          pailPerGallon -
          drumPerGallon;


        const savingsPercent =
          (
            perGallonSavings /
            pailPerGallon
          ) *
          100;


        const totalBulkSavings =
          (
            pailPerGallon *
            54
          ) -
          drumPrice;


        if (
          el.savings
        ) {

          el.savings.hidden =
            false;

        }


        if (
          el.savePerGallon
        ) {

          el.savePerGallon.textContent =
            `SAVE ${
              money.format(
                perGallonSavings
              )
            } / GAL`;

        }


        if (
          el.savePercent
        ) {

          el.savePercent.textContent =
            `${savingsPercent.toFixed(
              1
            )}%`;

        }


        if (
          totalBulkSavings >
            0 &&
          el.bulkSave &&
          el.bulkSaveText
        ) {

          el.bulkSave.hidden =
            false;


          el.bulkSaveText.textContent =
            `SAVE ${
              money.format(
                totalBulkSavings
              )
            }`;

        }

      }

    }


    function render(
      index,
      userInitiated =
        false
    ) {

      if (
        userInitiated
      ) {

        userInteracted =
          true;


        stopAutoCycle();

      }


      if (
        animation ===
          'race-start' &&
        !reducedMotion
      ) {

        runTree(
          () => {

            performRender(
              index
            );

          }
        );


        return;

      }


      performRender(
        index
      );

    }


    /* =====================================================
       TOGGLE
    ===================================================== */


    function openStation() {

      root.classList.remove(
        'is-collapsed'
      );


      if (
        el.toggle
      ) {

        el.toggle.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      if (
        el.toggleLabel
      ) {

        el.toggleLabel.textContent =
          closeText;

      }

    }


    function toggleStation() {

      const opening =
        root.classList.contains(
          'is-collapsed'
        );


      root.classList.toggle(
        'is-collapsed',
        !opening
      );


      if (
        el.toggle
      ) {

        el.toggle.setAttribute(
          'aria-expanded',
          opening
            ? 'true'
            : 'false'
        );

      }


      if (
        el.toggleLabel
      ) {

        el.toggleLabel.textContent =
          opening
            ? closeText
            : openText;

      }


      if (
        opening
      ) {

        runTree();

      }


      userInteracted =
        true;


      stopAutoCycle();

    }


    /* =====================================================
       PICKUP QUICK BUTTON
    ===================================================== */


    function activatePickupMode() {

      userInteracted =
        true;


      stopAutoCycle();


      openStation();


      applyFilter(
        'pickup',
        true
      );


      setTimeout(
        () => {

          const selector =
            root.querySelector(
              '.lm-fuel-station__selector'
            );


          selector?.scrollIntoView(
            {
              behavior:
                reducedMotion
                  ? 'auto'
                  : 'smooth',

              block:
                'start'
            }
          );

        },

        220
      );

    }


    /* =====================================================
       AUTO CYCLE
    ===================================================== */


    function stopAutoCycle() {

      if (
        autoTimer
      ) {

        clearInterval(
          autoTimer
        );


        autoTimer =
          null;

      }

    }


    function startAutoCycle() {

      if (
        !autoCycle ||
        reducedMotion ||
        userInteracted ||
        fuels.length <
          2
      ) {

        return;

      }


      stopAutoCycle();


      autoTimer =
        setInterval(
          () => {

            let next =
              (
                activeIndex +
                1
              ) %
              fuels.length;


            if (
              activeFilter !==
              'all'
            ) {

              let attempts =
                0;


              while (
                !fuelMatchesFilter(
                  fuels[
                    next
                  ],
                  activeFilter
                ) &&
                attempts <
                  fuels.length
              ) {

                next =
                  (
                    next +
                    1
                  ) %
                  fuels.length;


                attempts++;

              }

            }


            render(
              next,
              false
            );

          },

          cycleSeconds *
          1000
        );

    }


    /* =====================================================
       EVENTS
    ===================================================== */


    fuels.forEach(
      (fuel,index) => {

        fuel.addEventListener(
          'click',
          () => {

            render(
              index,
              true
            );

          }
        );

      }
    );


    filters.forEach(
      filter => {

        filter.addEventListener(
          'click',
          () => {

            applyFilter(
              filter.dataset
                .lmFilter,
              false
            );


            userInteracted =
              true;


            stopAutoCycle();

          }
        );

      }
    );


    el.toggle
      ?.addEventListener(
        'click',
        toggleStation
      );


    el.pickupQuick
      ?.addEventListener(
        'click',
        activatePickupMode
      );


    el.clearPickup
      ?.addEventListener(
        'click',
        () => {

          applyFilter(
            'all',
            false
          );

        }
      );


    /* =====================================================
       INITIALIZE
    ===================================================== */


    prepareFilters();


    performRender(
      0
    );


    startAutoCycle();

  }


  function initAll(
    scope =
      document
  ) {

    scope
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initStation
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initAll();

      }
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    event => {

      initAll(
        event.target
      );

    }
  );

})();